<template>
  <div class="container">
    <div class="oferta-container padding-17-left-right">
      <wrap-container class="w100">
        <wrap-container class="main-title">
          <head-title :title="titulo" class="titulo" />
          <p id="subtitulo" class="subtitulo oscuro">
            {{ subtitulo }}
          </p>
        </wrap-container>
      </wrap-container>
      <wrap-container
        class="w100"
        :class="
          offers.length > 1
            ? 'grid-container grid-container--6-6'
            : 'no-grid-container'
        "
      >
        <div
          v-for="(offer, index) in offers"
          :key="offer.title"
          :class="getColClass(offers.length, index)"
        >
          <offer-panel
            :fullWidth="offers.length === 1"
            :title="offer.title"
            :description="offer.description"
            :button="offer.button"
          />
        </div>
      </wrap-container>
      <wrap-container
        class="w100 pasos-section no-grid-container"
        v-if="cambioDePerfil"
      >
        <div class="pasos-tvos">
          <box-steps v-bind="stepsCambioDePerfil" />
        </div>
      </wrap-container>
      <wrap-container class="w100 qr-section">
        <div class="qr-container grid-container">
          <div class="code-container">
            <openmarket-QR
              class="qr-code"
              :scale="15"
              errorCorrectionLevel="L"
              :url="getURLQR()"
            />
          </div>
          <div class="sms-container">
            <head-title :title="qrTitle" class="sms-title" />
            <p class="sms-send">
              Escaneá el código QR o recibí un SMS.
            </p>
            <custom-send-sms-link
              label="Enviar SMS"
              :hideIcon="true"
              @click.native="openModalSMS"
            />
          </div>
        </div>
      </wrap-container>
      <modal-sms
        :show="showModal"
        @close="showModal = false"
        @sendSMS="sendSMS"
        buttonLabel="Enviar SMS"
        :mensaje="mensajeCuenta"
      />
    </div>
  </div>
</template>
<script>
import WrapContainer from "@/components/core/Container";
import OfferPanel from "@/components/core/OfferPanel";
import CustomSendSmsLink from "@/components/core/CustomSendSmsLink";
import OpenmarketQR from "@/components/core/OpenmarketQR";
import ModalSms from "@/components/core/modals/ModalSms";
import HeadTitle from "@/components/core/HeadTitle";
import BoxSteps from "@/components/core/BoxSteps";
import { motorTCCA } from "@/config/brands/ofertaCajaAhorro";
import { formatDinero } from "@/utils";
import offerPage from "@/mixins/offer-page";

export default {
  name: "ofertaTCCA",
  mixins: [offerPage],
  components: {
    WrapContainer,
    OfferPanel,
    OpenmarketQR,
    CustomSendSmsLink,
    ModalSms,
    HeadTitle,
    BoxSteps
  },
  data() {
    return {
      showModal: false,
      currentOffer: this.$store.getters.getOferta()
    };
  },
  computed: {
    titulo() {
      if (this.offers.length === 1) {
        return "Tenemos esta propuesta para vos";
      }
      return "Tenemos estas propuestas para vos";
    },
    subtitulo() {
      if (this.cambioDePerfil) {
        return "Cambiate a BBVA Vos y accedé a una tarjeta de crédito";
      }
      if (this.offers.length === 1) {
        return "Abrí tu Caja de ahorro en BBVA";
      }
      return "Podés elegir entre estás dos opciones:";
    },
    offers() {
      const { debito } = motorTCCA;
      const packageOffer = this.getPackageOffer();
      const cardDetail = motorTCCA[packageOffer];
      if (!cardDetail) return [];

      let CADebito = [];
      let isDebito =
        cardDetail.cards.includes("Débito") || cardDetail.cards.includes("Vos");

      if (
        this.currentOffer?.tipoSolicitud !== "V" &&
        packageOffer !== "debito"
      ) {
        CADebito = [
          {
            title: "Caja de ahorro",
            description: {
              cardType: "Tarjeta de débito",
              cardName: "Visa Débito",
              cardImage: {
                src: require(`@/assets/img/ofertaTCCA/${debito.image}`),
                alt: "Tarjeta Débito"
              },
              cardDetails: debito.details,
              cardCost: debito.benefit,
              cardMaintenance: this.getMaintenance(debito.maintenance)
            },
            button: {
              label: "Solicitar",
              action: this.getDebitoAction
            }
          }
        ];
      }

      const cardDetailsList =
        this.cambioDePerfil || packageOffer == "debito"
          ? cardDetail.details
          : this.getCardDetails([...debito.details, ...cardDetail.details]);

      if (["09", "04", "08", "01"].includes(packageOffer)) {
        cardDetailsList[0].label =
          "Tarjeta de débito Visa, una caja de ahorro en pesos y otra en dólares.";
      }

      if (packageOffer === "04" && window.innerWidth < 600) {
        CADebito[0].description.cardDetails.unshift(cardDetail.extraDetails);
      }

      return [
        ...CADebito,
        {
          title: cardDetail.accountName,
          description: {
            cardType: isDebito ? "Tarjeta de débito" : "Tarjeta de crédito",
            cardName: cardDetail.cards,
            cardImage: {
              src: require(`@/assets/img/ofertaTCCA/${cardDetail.image}`),
              alt: cardDetail.cards
            },
            cardDetails: cardDetailsList,
            cardCost: cardDetail.benefit,
            cardMaintenance: this.getMaintenance(cardDetail.maintenance)
          },
          button: {
            label: "Solicitar",
            action:
              packageOffer == "debito"
                ? this.getDebitoAction
                : this.getTarjetasAction
          }
        }
      ];
    },
    mensajeCuenta() {
      let mensaje;
      if (_BBVA_MOTOR === "ofertaCajaAhorro") {
        mensaje = "Obten&#233; tu Caja de ahorro ahora ingresando a ";
      }
      return mensaje;
    },
    cambioDePerfil() {
      const { tarjetaVos, tipoSolicitud } = this.currentOffer;
      return tarjetaVos && tipoSolicitud === "V";
    },
    stepsCambioDePerfil() {
      const packageOffer = this.getPackageOffer();
      const { process } = motorTCCA[packageOffer];
      return { ...process, imgSrc: "assets/img/ofertaTCCA/" };
    },
    qrTitle() {
      if (this.cambioDePerfil) {
        return "Podés elegir está opción desde tu celular";
      }
      return "Podés elegir la opción que prefieras desde tu celular.";
    }
  },
  methods: {
    getColClass(length, index) {
      if (length === 1) return "col-full";
      return `col${index + 1}`;
    },
    getMaintenance(card) {
      if (card > 0) return `Costo sin bonificación: $${formatDinero(card)}`;
      return "No tiene costo de mantenimiento";
    },
    getPackageOffer() {
      const { primerPaquete, tarjetaVos, tipoSolicitud } = this.currentOffer;
      let tipoPaquete = primerPaquete?.tipoPaquete;

      if (!tipoPaquete && tarjetaVos && tipoSolicitud !== "V") {
        tipoPaquete = "tvos";
      }

      if (!tipoPaquete && tarjetaVos && tipoSolicitud === "V") {
        tipoPaquete = "cambioPerfil";
      }

      switch (tipoPaquete) {
        case "09":
        case "01":
        case "08":
        case "04":
          return tipoPaquete;
        case "tvos":
          return "vos";
        case "cambioPerfil":
          return "cambioPerfil";
        default:
          return "debito";
      }
    },
    getCardDetails(details) {
      const { primerPaquete } = this.currentOffer;

      const visaDetails =
        primerPaquete?.tarjetas.find(card =>
          ["CI", "PP", "LL", "SS"].includes(card.tipoTarjeta)
        ) || {};

      const masterDetails =
        primerPaquete?.tarjetas.find(card =>
          ["12", "13", "18", "43"].includes(card.tipoTarjeta)
        ) || {};

      return details.map(detail => ({
        label: detail.label
          .replace("$visa_amount", `$${formatDinero(visaDetails.limite)}`)
          .replace(
            "$mastercard_amount",
            `$${formatDinero(masterDetails.limite)}`
          )
      }));
    },
    getTarjetasAction() {
      const globalVar = `${window.location.origin}${process.env.VUE_APP_TARJETAS}/#/`;
      const tarjetasUrl = new URL(globalVar);
      tarjetasUrl.searchParams.set("hash", window.hash);
      tarjetasUrl.searchParams.set("motorTCCA", "1");
      window.location.href = tarjetasUrl.href;
    },
    getDebitoAction() {
      this.$router.push(this.config.pasos.ofertaCuenta.pasoSiguiente);
    }
  }
};
</script>
<style scoped>
.titulo {
  font-size: 1.875rem;
  margin-bottom: 24px;
}
#subtitulo {
  margin-bottom: 24px;
}
.no-grid-container {
  margin-bottom: 24px;
}
.qr-section {
  display: none;
  margin-top: 40px;
  margin-bottom: 40px;
}
.qr-container {
  border-radius: 16px;
  background-color: #f7f8f8;
  padding: 60px 16px;
}
.code-container {
  grid-column-start: col2;
  grid-column-end: col4;
  text-align: right;
}
.sms-container {
  grid-column-start: col5;
  grid-column-end: col10;
  align-self: center;
  padding-left: 40px;
}
.qr-code {
  max-width: 200px;
  box-shadow: 0 3px 40px rgba(143, 143, 143, 0.5);
  border-radius: 10px;
  overflow: hidden;
  background-color: #fff;
}
.sms-title {
  font-size: 1.875rem;
  font-weight: 700;
  line-height: 2.425rem;
}
.sms-send {
  font-size: 1.25rem;
  margin-top: 14px;
  margin-bottom: 14px;
}
@media screen and (min-width: 600px) {
  .titulo {
    font-size: 2.375rem;
  }
  #subtitulo {
    font-size: 1.313rem;
    margin-bottom: 48px;
  }
  .pasos-section {
    margin-top: 40px;
  }
  .qr-section {
    display: block;
  }
}
</style>
